import React, { useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Autocomplete,
  TextField,
  Typography,
  Box,
  Grid,
  FormControl,
  Select,
  Checkbox,
  MenuItem,
  FormGroup,
  InputLabel,
  Tooltip,
  Button,
  Switch,
} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  LocalizationProvider,
  DatePicker,
  DateTimePicker,
  TimePicker,
} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {
  RentalFields,
  // airportTransfer,
  bookingFormBorder,
  branchOption,
  employeeCode,
  existingUser,
  fromAirportForm,
  newBranch,
  newUser,
  outstationFields,
  toAirportForm,
} from "pages/frontDesk/FrontDeskData";
import CommonButton from "components/commonButton/CommonButton";
import {
  handleValidationForm,
  reservationHeader,
  truncateComment,
} from "utils/utils";
import {
  dutyTypeEnum,
  minimumBookingHours,
  rolesEnum,
  tripDutyTypeEnum,
} from "utils/enumObj";
import FareBreakUp from "pages/frontDesk/FareBreakup";
import CabFacilities from "pages/frontDesk/CabFacilities";
import CommonDateTimePicker from "./commonDateTimePicker/CommonDateTimePicker";
import CommonGoogleAutoComplete from "./CommonGoogleAutoComplete/CommonGoogleAutoComplete";
import Loader from "components/loader/Loader";
import "./CommonMultiForm.scss";
import { clearPlaceDetails } from "redux/actions/UserGoogleMap";
import CustomTextfield from "./customTextfield/CustomTextfield";
import PreviewIcon from "@mui/icons-material/Visibility";
import PlacardModal from "components/placardModal/PlacardModal";

export default function CommonMultiForm(props) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    setError,
    control,
    formState: { errors },
    clearErrors,
  } = useForm({ defaultValues: props?.defaultValues, mode: "onChange" });

  watch(); // Force reactive re-renders when form values change

  const formValues = getValues();
  let date = new Date();
  const [minDate, setMinDate] = useState(date);

  useEffect(() => {
    setMinDate(
      date.setMinutes(
        Math.ceil(date.getMinutes() / 10) * 10 +
          (props?.bookingBufferTime || 0) / 60,
      ),
    );
  }, [props?.bookingBufferTime]);

  const [formError, setFormError] = useState([]);
  const [selectValues, setSelectValues] = useState();
  const [formData, setFormData] = useState({});
  const [previewModal, setPreviewModal] = useState(false);
  const [selectedTripId, setSelectedTripId] = useState("");
  const [mandatoryField, setMandatoryField] = useState({
    field: "",
    status: false,
  });

  const [autoCompleteFieldValue, setAutoCompletFieldValue] = useState({
    location: "",
    dutyTypeId: "",
    vehicleCategoryId: "",
  });

  const [landmarkMandatory, setlandmarkMandatory] = useState({
    landMark: props.editType || props.extensionMode ? false : true,
    pickUp: props.editType || props.extensionMode ? false : true,
  });

  // ---Country Code---
  const [country, setCountry] = useState("+91");

  const userProfile = useSelector(
    (state) => state?.userProfile?.profileDetails?.data,
  );

  let domainName = userProfile?.email?.split("@")[1];
  const userRole = localStorage.getItem("role");

  const [formValidationObj, setFormValidationObj] = useState({});
  const [guestDetails, setGuestDetails] = useState([]);

  //Handling useEffect for adding default values
  useEffect(() => {
    if (props.defaultValues) {
      setAutoCompletFieldValue(props?.defaultValues);
    }
  }, []);

  useEffect(() => {
    setCountry(props?.defaultValues?.countryCode || "+91");
  }, [props?.defaultValues?.countryCode]);

  //Handling useEffect for adding edit forms
  useEffect(() => {
    if (props.editType || props.extensionMode) {
      let tempFormData = props?.formData;
      if (
        props.defaultValues?.dutyTypeOption?.[0]?.id ===
        tripDutyTypeEnum.airpotTransfer
      ) {
        if (props.defaultValues?.airportRideType === "To-Airport") {
          tempFormData["tripDetails"] = [
            ...toAirportForm(
              props.defaultValues?.toAirportTerminalList,
              props?.editType || props.extensionMode,
            ),
          ];
        } else {
          tempFormData["tripDetails"] = [
            ...fromAirportForm(
              props.defaultValues?.fromAirportTerminalList,
              props?.editType || props.extensionMode,
            ),
          ];
        }
      } else if (
        props.defaultValues?.dutyTypeOption?.[0]?.id === tripDutyTypeEnum.rental
      ) {
        tempFormData["tripDetails"] = [
          ...RentalFields(
            props?.rateCardPackage,
            props?.editType,
            props.extensionMode,
            false,
          ),
        ];
      } else {
        tempFormData["tripDetails"] = [
          ...outstationFields(props?.editType || props.extensionMode),
        ];
      }
      setFormData(tempFormData);
    } else {
      if (props?.formData) {
        setFormData(props?.formData);
      }
    }
  }, []);

  //Handling useEffect for adding dropdown options for select and autocomplete field
  useEffect(() => {
    let tempFormData = { ...formData };
    let hasChanges = false;

    if (props?.cityOption && tempFormData["dutyAndVehicle"]) {
      const locationField = tempFormData["dutyAndVehicle"].find(
        (field) => field.name === "location",
      );
      if (locationField) {
        locationField.optionData = props?.cityOption || [];
        hasChanges = true;
      }
    }
    if (props?.dutyTypeOption && tempFormData["dutyAndVehicle"]) {
      const dutyTypeField = tempFormData["dutyAndVehicle"].find(
        (field) => field.name === "dutyTypeId",
      );
      if (dutyTypeField) {
        dutyTypeField.optionData = props?.dutyTypeOption || [];
        hasChanges = true;
      }
    }
    if (props?.carOption && tempFormData["dutyAndVehicle"]) {
      const vehicleField = tempFormData["dutyAndVehicle"].find(
        (field) => field.name === "vehicleCategoryId",
      );
      if (vehicleField) {
        vehicleField.optionData = props?.carOption || [];
        hasChanges = true;
      }
    }

    if (hasChanges) {
      setFormData(tempFormData);
    }
  }, [
    props?.branchOption,
    props?.cityOption,
    props?.dutyTypeOption,
    props?.carOption,
    formData,
  ]);

  //Handling useEffect for adding dropdown options for airport terminal list
  useEffect(() => {
    let tempFormData = { ...formData };
    let hasChanges = false;

    if (
      props?.airportTerminalOption &&
      tempFormData["tripDetails"]?.length > 0 &&
      !props.editType
    ) {
      const toAirportField = tempFormData["tripDetails"].find(
        (field) => field.name === "toAirportTerminal",
      );
      const fromAirportField = tempFormData["tripDetails"].find(
        (field) => field.name === "fromAirportTerminal",
      );

      if (toAirportField) {
        toAirportField.menuOptions = props?.airportTerminalOption;
        hasChanges = true;
      }
      if (fromAirportField) {
        fromAirportField.menuOptions = props?.airportTerminalOption;
        hasChanges = true;
      }
    }

    if (hasChanges) {
      setFormData(tempFormData);
    }
  }, [props?.airportTerminalOption, formData, props?.editType]);

  //Handling useEffect for adding dropdown options for ratecard package
  useEffect(() => {
    let tempFormData = { ...formData };
    let hasChanges = false;

    if (props?.rateCardPackage && tempFormData["tripDetails"]) {
      const packageField = tempFormData["tripDetails"].find(
        (field) => field.name === "package",
      );
      if (packageField) {
        packageField.menuOptions = props?.rateCardPackage;
        hasChanges = true;
      }
    }

    if (hasChanges) {
      setFormData(tempFormData);
    }
  }, [props?.rateCardPackage, formData]);

  //Handling useEffect for adding dropdown options for employees list
  useEffect(() => {
    let tempFormData = formData;
    if (props?.companyEmployeelist && tempFormData["travellerDetails"]) {
      if (tempFormData["travellerDetails"][1]?.name === "employeeEmail") {
        tempFormData["travellerDetails"][1].optionData =
          props?.companyEmployeelist || [];
        setFormData(tempFormData);
      }
    }
  }, [props?.companyEmployeelist, formData]);

  //Handling useEffect for updating default values
  useEffect(() => {
    if (props.defaultValues) {
      setSelectValues(props.defaultValues);
    }
  }, [props.defaultValues]);

  // Handle extension mode - read trip details and prefill form
  useEffect(() => {
    if (props.extensionMode && props.tripDetails) {
      const tripDetails = props.tripDetails;
      // Prefill the multiDay booking toggle
      if (tripDetails?.additionalInfo?.multiDay) {
        setValue("multiDayBooking", true);
        // Prefill the end date with the current end date from multiDay
        if (tripDetails.additionalInfo.multiDay.endDate) {
          setValue(
            "endDateTime",
            dayjs(tripDetails.additionalInfo.multiDay.endDate),
          );
        }
      }
      // Prefill source address (only editable field besides endDateTime)
      if (tripDetails?.sourceAddress) {
        setValue("pickUp", {
          description: tripDetails.sourceAddress,
          structured_formatting: {
            main_text: tripDetails.sourceAddress,
            secondary_text: tripDetails.sourceAddress,
          },
        });
      }
    }
  }, [props.extensionMode, props.tripDetails, setValue]);

  useEffect(() => {
    const travelerCount = parseInt(formValues?.noOfTravelers - 1 || 0);

    if (travelerCount > 0) {
      // Initialize guest details array
      const newGuestDetails = Array.from(
        { length: travelerCount },
        (_, index) => ({
          id: index,
          name: "",
          phone: "",
          countryCode: "+91",
        }),
      );
      setGuestDetails(newGuestDetails);

      // Set form values for each guest if they don't exist
      newGuestDetails.forEach((_, index) => {
        if (!formValues[`guestName_${index}`]) {
          setValue(`guestName_${index}`, "");
        }
        if (!formValues[`guestPhone_${index}`]) {
          setValue(`guestPhone_${index}`, "");
        }
        if (!formValues[`guestCountryCode_${index}`]) {
          setValue(`guestCountryCode_${index}`, "+91");
        }
      });
    } else {
      setGuestDetails([]);
    }
  }, [formValues?.noOfTravelers, setValue]); // Watch for changes in noOfTravelers

  const { existingBranch, newBranch } = branchOption();

  // Preview functionality handlers
  const handlePlacardPreview = () => {
    const placardText = getValues("placardText"); // Get placard text from form
    if (placardText) {
      setSelectedTripId(placardText); // We'll reuse this state to store placard text
      setPreviewModal(true);
    }
  };

  const handlePreviewClose = () => {
    setPreviewModal(false);
  };

  // Field visibility logic
  const shouldRenderField = (field) => {
    if (!field) return false;
    // Check for placard fields
    if (field.name === "needPlacard" || field.name === "placardText") {
      const dutyVal = getValues("dutyTypeId");
      const dutyTypeId = dutyVal?.tripType;
      // Only show for Airport Transfer and Rental
      const isValidDutyType =
        dutyTypeId === tripDutyTypeEnum.airpotTransfer ||
        dutyTypeId === tripDutyTypeEnum.rental;
      if (field.name === "placardText") {
        return isValidDutyType && getValues("needPlacard") === true;
      }
      return isValidDutyType;
    }
    // Duty Type check for other fields
    if (field?.showForDutyTypes) {
      const dutyVal = getValues("dutyTypeId");
      const selectedDutyLabel =
        (dutyVal && (dutyVal.label || dutyVal.name || dutyVal)) || "";
      if (!field.showForDutyTypes.includes(selectedDutyLabel)) {
        return false;
      }
    }

    // Check dependent fields
    if (field?.dependentField) {
      if (Array.isArray(field.dependentField)) {
        for (const dep of field.dependentField) {
          if (!getValues(dep)) return false;
        }
      } else {
        if (!getValues(field.dependentField)) return false;
      }
    }

    // showWhenEquals: { field: "fieldName", value: expectedValue }
    // Only renders when the specified field equals the expected value
    if (field?.showWhenEquals) {
      const { field: watchField, value: expectedValue } = field.showWhenEquals;
      const currentVal = getValues(watchField);
      if (String(currentVal) !== String(expectedValue)) {
        return false;
      }
    }

    return true;
  };

  const handleInput = (e, name, fieldValue) => {
    const fieldName = name || e.target.name;
    clearErrors(fieldName);
    const defaultFieldValues = [
      "employeeEmail",
      "dutyTypeId",
      "location",
      "vehicleCategoryId",
    ];
    const data = {
      ...formValidationObj,
    };

    if (fieldName === "airportRideType") {
      if (fieldValue === "To-Airport") {
        setFormData({
          ...formData,
          tripDetails: [
            ...toAirportForm(props?.airportTerminalOption, props?.editType),
          ],
        });
      } else if (fieldValue === "From-Airport") {
        setFormData({
          ...formData,
          tripDetails: [
            ...fromAirportForm(props?.airportTerminalOption, props?.editType),
          ],
        });
      }
    } else if (fieldName === "travellerType") {
      setValue("employeeEmail", "");
      setValue("employeePhoneNumber", "");
      setValue("employeeName", "");
      setValue("employeeCode", "");
      setValue("departmentCode", "");
      setValue("employeeBranch", "");
      setValue("employeeBranchId", "");
      setValue("billingTypeAccess", "");

      const billingModeField = (disabled) => ({
        radio: true,
        required: true,
        gridSize: 8,
        label: "Billing Mode",
        name: "billingTypeAccess",
        fieldDisabled: disabled,
        values: [
          { value: 1, label: "Bill to Self" },
          { value: 2, label: "Bill to Company" },
          // { value: 3, label: "Both" },
        ],
      });

      let tempData = [...formData["travellerDetails"]];
      setCountry("+91");
      tempData = tempData.filter((item) => item?.name !== "billingTypeAccess");
      const billingModeIndex = tempData.findIndex(
        (item) => item?.name === "travelRequestNumber",
      );

      if (fieldValue === "newTraveller") {
        tempData[1] = newUser;
        tempData[4] = employeeCode;
        tempData[5].required = true;
        tempData[6] = newBranch(props?.branchOption, props?.editType);

        tempData.splice(billingModeIndex + 1, 0, billingModeField(false));
      } else if (fieldValue === "guestTraveller") {
        tempData[1] = newUser;
        tempData[4] = "";
        tempData[5].required = false;
        tempData[6] = newBranch(props?.branchOption, props?.editType);

        tempData.splice(billingModeIndex + 1, 0, billingModeField(false));
      } else if (fieldValue === "existingTraveller") {
        tempData[1] = existingUser(props?.companyEmployeelist);
        tempData[4] = employeeCode;
        tempData[5].required = true;
        tempData[6] = existingBranch(props?.branchOption, props?.editType);

        tempData.splice(billingModeIndex + 1, 0, billingModeField(true));

        // Fetch countryCode dynamically from existing user details
        const existingUserDetails = props?.companyEmployeelist?.find(
          (user) => user.email === fieldValue?.email,
        );
        setCountry(existingUserDetails?.countryCode || "+91");
      }

      setFormData({ ...formData, travellerDetails: [...tempData] });
      setValue(name, fieldValue);
    } else if (fieldName === "location") {
      setAutoCompletFieldValue({
        ...autoCompleteFieldValue,
        dutyTypeId: null,
        vehicleCategoryId: null,
        [fieldName]: fieldValue,
      });

      setFormData({
        ...formData,
        tripDetails: [bookingFormBorder],
      });

      setValue("vehicleCategoryId", "");
      setValue("dutyTypeId", "");
      props.fetchDutyType(fieldValue);
    } else if (fieldName === "dutyTypeId") {
      if (formValues?.dutyTypeId !== fieldValue?.tripType) {
        setValue("drop", "");
      }
      setlandmarkMandatory({
        ...landmarkMandatory,
        landMark: true,
        pickUp: true,
      });

      setAutoCompletFieldValue({
        ...autoCompleteFieldValue,
        vehicleCategoryId: null,
        [fieldName]: fieldValue,
      });

      // Reset form fields
      setValue("vehicleCategoryId", "");
      setValue("package", "");
      setValue("noOfTravelers", "");
      setValue("pickUp", "");
      setValue("drop", "");
      setValue("landMark", "");
      setValue("needPlacard", false);
      setValue("placardText", "");

      props.fetchVehicleCategroy(fieldValue);
      props.fetchRateCard(fieldName, fieldValue?.tripType);
      dispatch(clearPlaceDetails());

      if (fieldValue?.tripType === tripDutyTypeEnum?.airpotTransfer) {
        setFormData({
          ...formData,
          tripDetails: [
            ...toAirportForm(props?.airportTerminalOption, props?.editType),
          ],
        });
      } else if (fieldValue?.tripType === tripDutyTypeEnum?.rental) {
        setFormData({
          ...formData,
          tripDetails: [
            ...RentalFields(
              props?.rateCardPackage,
              props?.editType,
              props.extensionMode,
            ),
          ],
        });
      } else {
        setFormData({
          ...formData,
          tripDetails: [...outstationFields(props?.editType)],
        });
      }
    } else if (fieldName === "vehicleCategoryId" || fieldName === "branch") {
      setValue("vehicleSeater", fieldValue?.seater || 0);

      if (!fieldValue?.value) {
        setValue("noOfTravelers", "");
      }

      setAutoCompletFieldValue({
        ...autoCompleteFieldValue,
        [fieldName]: fieldValue,
      });

      props.fetchRateCard(fieldName, fieldValue?.value);
    } else if (fieldName === "tripType") {
      if (e.target.value === "6") {
        setMandatoryField({ ...mandatoryField, field: "oneway", status: true });
      } else if (e.target.value === "7") {
        setMandatoryField({
          ...mandatoryField,
          field: "roundTrip",
          status: true,
        });
      }
    } else if (
      fieldName === "fromAirportTerminal" ||
      fieldName === "toAirportTerminal"
    ) {
      const destinationAddress = props?.airportTerminalOption?.filter(
        (obj) => obj.value === e.target.value,
      );
      props?.onHandleChange(e, destinationAddress?.[0], e.target.name);
    } else if (fieldName === "employeeEmail") {
      const employeeList = props?.employeeList ? props?.employeeList : [{}];
      const filteredEmployeeDetails = employeeList?.filter(
        (obj) => obj.email === fieldValue?.value,
      );
      setValue("employeeEmail", filteredEmployeeDetails?.[0]?.email);
      setValue(
        "employeePhoneNumber",
        filteredEmployeeDetails?.[0]?.phoneNumber,
      );
      setValue("employeeName", filteredEmployeeDetails?.[0]?.name);
      setValue("employeeCode", filteredEmployeeDetails?.[0]?.employeeId);
      setValue("departmentCode", filteredEmployeeDetails?.[0]?.code);
      setValue("employeeBranch", filteredEmployeeDetails?.[0]?.branchAddress);
      setValue("employeeBranchId", filteredEmployeeDetails?.[0]?.branchId);
      const empBillingType = Number(
        filteredEmployeeDetails?.[0]?.billingTypeAccess,
      );
      const isBoth = empBillingType === 3;
      const billingVal = isBoth
        ? ""
        : (filteredEmployeeDetails?.[0]?.billingTypeAccess ?? "");

      setValue("billingTypeAccess", billingVal);
      setCountry(filteredEmployeeDetails?.[0]?.countryCode || "+91");
      setFormValidationObj((prev) => ({
        ...prev,
        billingTypeAccess: billingVal,
      }));

      const updatedTravellerDetails = formData["travellerDetails"]?.map(
        (item) => {
          if (item?.name === "billingTypeAccess") {
            return {
              ...item,
              fieldDisabled: !isBoth,
            };
          }
          return item;
        },
      );
      if (updatedTravellerDetails) {
        setFormData((prev) => ({
          ...prev,
          travellerDetails: updatedTravellerDetails,
        }));
      }
      const clearErrorFileds = [
        "employeeEmail",
        "employeePhoneNumber",
        "employeeName",
        "employeeCode",
        "departmentCode",
        "employeeBranch",
        "employeeBranchId",
      ];

      let i = 0;
      while (i < clearErrorFileds?.length) {
        clearErrors(clearErrorFileds[i]);
        i++;
      }
    }

    if (defaultFieldValues?.includes(fieldName)) {
      setValue(name, fieldValue);
    } else if (fieldName === "newBranch") {
      setValue("employeeBranchId", e.target.value);
    } else if (fieldName === "multiDayBooking") {
      const boolVal =
        typeof fieldValue === "boolean"
          ? fieldValue
          : fieldValue?.toString().toLowerCase() === "true";
      setValue("multiDayBooking", boolVal, { shouldValidate: true });
      data[fieldName] = boolVal;
      setFormData({
        ...formData,
        tripDetails: [
          ...RentalFields(
            props?.rateCardPackage,
            props?.editType,
            props.extensionMode,
            boolVal,
          ),
        ],
      });
    } else {
      if (fieldName !== "dutyTypeId") {
        setValue(name || e.target.name, fieldValue || e.target.value);
        setFormValidationObj({
          ...formValidationObj,
          [fieldName]: fieldValue || e.target.value,
        });
        data[fieldName] = fieldValue || e.target.value;
        let validationData = handleValidationForm(data, domainName, formValues);
        setFormError(validationData.errorVal);
      }
    }
  };

  const handleChange = (event) => {
    setCountry(event.target.value);
  };

  // ---Form Validation---
  const handelNegativeInput = (event) => {
    // Check if the input value is valid
    if (!event.target.validity.valid) {
      // If not valid, clear the input value
      setValue(event?.target.name, "");
    }
  };

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur();
    // Prevent the page/container scrolling
    e.stopPropagation();
  };

  const dummyFunctiom = (e) => {
    return;
  };

  const onInputChangeVal = (event, value) => {
    props?.onInputChangeVal(event, value, formValues);
  };

  const handleAutoSuggestionSearch = (event, value, fieldName) => {
    if (fieldName === "employeeEmail") {
      props?.handleAutoSuggestionSearch(event, value);
    }
  };

  const onHandleChange = (event, value, name) => {
    props?.onHandleChange(event, value, name);
    const clearErrorFiled = ["landMark"];
    if (name === "pickUp") {
      if (event.type === "change" && !value) {
        setlandmarkMandatory({ landMark: true, pickUp: true });
      } else {
        setlandmarkMandatory({ landMark: false, pickUp: true });
      }
    }
    clearErrors(clearErrorFiled);
  };

  const onSubmit = (data) => {
    let validationData = handleValidationForm(data, domainName, formValues);
    setFormError(validationData.errorVal);

    // if (guestDetails.length > 0) {
    //   const isGuestDetailsValid = validateGuestDetails();
    //   if (!isGuestDetailsValid) {
    //     return; // Stop submission if guest details are invalid
    //   }
    // }

    // Process guest details
    const finalGuestDetails = guestDetails.map((guest, index) => ({
      name: data[`guestName_${index}`] || "",
      phone: data[`guestPhone_${index}`] || "",
      countryCode: data[`guestCountryCode_${index}`] || "",
    }));

    // Add guest details to form data
    const formDataWithGuests = {
      ...data,
      guestDetails: finalGuestDetails,
    };

    if (validationData.formIsValid) {
      props.onSubmittBtn(formDataWithGuests, country);
    }
  };

  const handleDisable = (previewDisabled, editDisabled, fieldName) => {
    // In extension mode, disable all fields except specific ones
    if (props.extensionMode && isFieldDisabledInExtensionMode(fieldName)) {
      return true;
    }
    if (
      (fieldName === "noOfTravelers" &&
        !autoCompleteFieldValue?.vehicleCategoryId?.value) ||
      previewDisabled ||
      editDisabled
    ) {
      return true;
    }
  };

  // Determine which fields should be disabled in extension mode
  const isFieldDisabledInExtensionMode = (fieldName) => {
    // Only sourceAddress (pickUp) and endDateTime should be editable in extension mode

    const editableFields = ["pickUp", "endDateTime"];
    return !editableFields.includes(fieldName);
  };

  const getOptionLabel = (option) => {
    if (option?.description) {
      return option?.description;
    } else if (option?.formatted_address) {
      return option?.formatted_address;
    } else if (option?.vicinity) {
      return option?.name + "," + option?.vicinity;
    } else {
      return "";
    }
  };

  const validateGuestDetails = () => {
    let isValid = true;
    const guestErrors = {};

    guestDetails.forEach((guest, index) => {
      const guestName = formValues[`guestName_${index}`];
      const guestPhone = formValues[`guestPhone_${index}`];

      // Validate name field (mandatory)
      if (!guestName || guestName.trim() === "") {
        setError(`guestName_${index}`, {
          type: "manual",
          message: "Guest name is required",
        });
        isValid = false;
      }

      // Validate phone number field (mandatory)
      if (!guestPhone || guestPhone.trim() === "") {
        setError(`guestPhone_${index}`, {
          type: "manual",
          message: "Guest phone number is required",
        });
        isValid = false;
      } else {
        // Validate phone number length (10 digits)
        const phoneDigits = guestPhone.replace(/\D/g, "");
        if (phoneDigits.length !== 10) {
          setError(`guestPhone_${index}`, {
            type: "manual",
            message: "Phone number must be exactly 10 digits",
          });
          isValid = false;
        }
      }
    });

    return isValid;
  };

  const handleGuestNameChange = (e, index) => {
    const updatedGuests = [...guestDetails];
    updatedGuests[index].name = e.target.value;
    setGuestDetails(updatedGuests);

    // Clear error when user starts typing
    if (errors[`guestName_${index}`]) {
      clearErrors(`guestName_${index}`);
    }
  };

  const handleGuestPhoneChange = (e, index) => {
    const phoneValue = e.target.value.replace(/\D/g, "");

    const updatedGuests = [...guestDetails];
    updatedGuests[index].phone = phoneValue;
    setGuestDetails(updatedGuests);

    // Clear error when user starts typing
    if (errors[`guestPhone_${index}`]) {
      clearErrors(`guestPhone_${index}`);
    }

    // Validate phone number length in real-time
    if (phoneValue.length > 0 && phoneValue.length !== 10) {
      setError(`guestPhone_${index}`, {
        type: "manual",
        message: "Phone number must be exactly 10 digits",
      });
    }
  };

  return (
    <div>
      <div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={`${
            props.type === "complianceupload" ? "flexDirection" : null
          }`}
        >
          {formData &&
            Object.keys(formData).map((val, index) => (
              <Box className="multiform-component mt20" key={index}>
                <Box className="justifyBetween">
                  <Box>
                    <Typography
                      variant="head3"
                      component={"h1"}
                      className={`${
                        props.disabled ? "colorGrey" : "colorBlack"
                      } fw600`}
                    >
                      {reservationHeader(val)}
                    </Typography>
                  </Box>
                </Box>
                <Grid
                  container
                  spacing={{ md: 2 }}
                  columns={{ xs: 1, sm: 3, md: 12 }}
                >
                  {formData &&
                    formData[val].map((ele, idx) => {
                      // ele &&
                      if (!shouldRenderField(ele)) return null;
                      return (
                        <Grid item xs={12} sm={ele.gridSize} key={idx}>
                          <Box
                            display={"grid"}
                            key={ele?.name}
                            className={val !== "Billing Details" && "mb10"}
                          >
                            <FormControl variant="standard">
                              {ele?.label && ele?.label !== "Guest Details" && (
                                <Typography
                                  variant="body2"
                                  className="fw600 colorBlack mb10"
                                >
                                  {ele?.label}
                                  {(ele?.required ||
                                    (ele.name === "landMark" &&
                                      landmarkMandatory.landMark)) && (
                                    <span className="colorRed">
                                      {ele?.star || "*"}
                                    </span>
                                  )}

                                  {ele.name === "placardText" && (
                                    <Tooltip title="Preview Placard">
                                      <Button
                                        variant="text"
                                        size="small"
                                        onClick={handlePlacardPreview}
                                        sx={{
                                          minWidth: "40px",
                                          "& .MuiButton-startIcon": {
                                            margin: 0,
                                          },
                                        }}
                                      >
                                        <PreviewIcon fontSize="small" />
                                      </Button>
                                    </Tooltip>
                                  )}
                                </Typography>
                              )}
                              <Box className="flexDisplay">
                                {ele?.countrycode && (
                                  <Box className="customCountryCode">
                                    <FormControl>
                                      <Select
                                        disabled={handleDisable(
                                          ele?.fieldDisabled,
                                          props?.disabled,
                                          ele?.name,
                                        )}
                                        IconComponent={(params) => (
                                          <ExpandMoreRoundedIcon
                                            className="mr10"
                                            {...params}
                                          />
                                        )}
                                        value={country}
                                        onChange={handleChange}
                                        inputProps={{
                                          "aria-label": "Without label",
                                        }}
                                        className="br10"
                                        name="countryCode"
                                      >
                                        {(formValues?.travellerType !==
                                          "existingTraveller" &&
                                          props?.pageName === "reservation") ||
                                        props?.defaultValues.employeeType ===
                                          "newemployee" ? (
                                          props?.countryCodeListData &&
                                          props?.countryCodeListData?.length >
                                            0 &&
                                          props?.countryCodeListData?.map(
                                            (country) => (
                                              <MenuItem
                                                className="colorBlack"
                                                value={country?.value}
                                                key={country?.value}
                                              >
                                                {country?.label +
                                                  " " +
                                                  country?.value}
                                              </MenuItem>
                                            ),
                                          )
                                        ) : (
                                          <MenuItem
                                            className="colorBlack"
                                            value={country}
                                            key={country}
                                          >
                                            {country}
                                          </MenuItem>
                                        )}
                                      </Select>
                                    </FormControl>
                                  </Box>
                                )}
                                <FormControl
                                  fullWidth
                                  className="commonFormControl"
                                >
                                  {ele?.options ? (
                                    <Box className="customSelectOption">
                                      <Select
                                        defaultValue={
                                          selectValues
                                            ? selectValues[ele?.name]
                                            : ""
                                        }
                                        IconComponent={(params) => (
                                          <ExpandMoreRoundedIcon
                                            className="mr10"
                                            {...params}
                                          />
                                        )}
                                        disabled={handleDisable(
                                          ele?.fieldDisabled,
                                          props?.disabled,
                                          ele?.name,
                                        )}
                                        {...register(ele?.name, {
                                          required: ele?.required || false,
                                        })}
                                        onChange={(e) => handleInput(e)}
                                        displayEmpty
                                        inputProps={{
                                          "aria-label": "Without label",
                                        }}
                                      >
                                        <InputLabel className="colorGrey ml16">
                                          <Typography
                                            variant="body2"
                                            className="colorGrey"
                                          >
                                            {ele.placeholder}
                                          </Typography>
                                        </InputLabel>

                                        {ele?.menuOptions &&
                                          ele?.menuOptions?.length > 0 &&
                                          ele?.menuOptions?.map(
                                            (option, idx) => (
                                              <MenuItem
                                                key={idx}
                                                value={option?.value || ""}
                                              >
                                                {ele?.name ===
                                                  "fromAirportTerminal" ||
                                                ele?.name ===
                                                  "toAirportTerminal" ? (
                                                  <Tooltip
                                                    title={option?.label}
                                                    placement="bottom"
                                                  >
                                                    {truncateComment(
                                                      option?.label,
                                                      50,
                                                    )}
                                                  </Tooltip>
                                                ) : ele?.name === "newBranch" ||
                                                  ele?.name === "branchName" ? (
                                                  <Tooltip
                                                    title={option?.label}
                                                    placement="bottom"
                                                  >
                                                    {truncateComment(
                                                      option?.label,
                                                      40,
                                                    )}
                                                  </Tooltip>
                                                ) : (
                                                  option?.label
                                                )}
                                              </MenuItem>
                                            ),
                                          )}
                                      </Select>
                                      {props?.[`${ele?.name}Loader`]
                                        ?.fieldType === ele?.name &&
                                        props?.[`${ele?.name}Loader`]
                                          ?.loader && (
                                          <Box className="autoCompleteLoader">
                                            <Loader
                                              height="66px"
                                              loaderSize={"small"}
                                            />
                                          </Box>
                                        )}
                                    </Box>
                                  ) : ele?.radio ? (
                                    <FormControl>
                                      <Controller
                                        name={ele?.name}
                                        control={control}
                                        rules={{ required: ele?.required }}
                                        render={({ field }) => {
                                          return (
                                            <RadioGroup
                                              row
                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                              {...field}
                                              value={
                                                field.value ??
                                                selectValues?.[ele?.name] ??
                                                ""
                                              }
                                              onChange={(e) => {
                                                field.onChange(e.target.value);
                                                handleInput(
                                                  e,
                                                  ele?.name,
                                                  e.target.value,
                                                );
                                              }}
                                            >
                                              {ele?.values.map(
                                                (value, index) => (
                                                  <FormControlLabel
                                                    key={value.label}
                                                    value={value.value || ""}
                                                    control={
                                                      <Radio
                                                        disabled={handleDisable(
                                                          ele?.fieldDisabled,
                                                          props?.disabled,
                                                          ele?.name,
                                                        )}
                                                      />
                                                    }
                                                    label={value.label}
                                                  />
                                                ),
                                              )}
                                            </RadioGroup>
                                          );
                                        }}
                                      />
                                    </FormControl>
                                  ) : ele?.autoComplete ||
                                    ele?.reservationAutoComplete ? (
                                    <Box className="customAutoComplete">
                                      <Controller
                                        name={ele?.name}
                                        control={control}
                                        rules={{
                                          required: ele?.required || false,
                                        }}
                                        render={({ field }) => (
                                          <Autocomplete
                                            size="medium"
                                            name={ele?.name}
                                            hiddenlabel="true"
                                            clearIcon={null}
                                            value={
                                              ele?.reservationAutoComplete &&
                                              (autoCompleteFieldValue[
                                                ele?.name
                                              ] ||
                                                "")
                                            }
                                            popupIcon={
                                              <ExpandMoreRoundedIcon />
                                            }
                                            disabled={handleDisable(
                                              ele?.fieldDisabled,
                                              props?.disabled,
                                              ele?.name,
                                            )}
                                            onInputChange={(event, value) =>
                                              handleAutoSuggestionSearch(
                                                event,
                                                value,
                                                ele?.name,
                                              )
                                            }
                                            options={ele?.optionData}
                                            defaultValue={
                                              selectValues[ele?.name]?.value
                                                ? selectValues[ele?.name]
                                                : ""
                                            }
                                            filterSelectedOptions
                                            onChange={(e, value) =>
                                              handleInput(e, ele.name, value)
                                            }
                                            onBlur={field.onBlur}
                                            renderOption={(props, option) => (
                                              <Box {...props}>
                                                {option.label}
                                              </Box>
                                            )}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                margin="normal"
                                                placeholder={ele?.placeholder}
                                                inputProps={{
                                                  ...params.inputProps,
                                                  autoComplete: "disabled",
                                                }}
                                              />
                                            )}
                                          />
                                        )}
                                      />
                                      {props?.[`${ele?.name}Loader`]
                                        ?.fieldType === ele?.name &&
                                        props?.[`${ele?.name}Loader`]
                                          ?.loader && (
                                          <Box className="autoCompleteLoader">
                                            <Loader
                                              height="66px"
                                              loaderSize={"small"}
                                            />
                                          </Box>
                                        )}
                                    </Box>
                                  ) : ele?.checkbox ? (
                                    <FormGroup
                                      className={`${ele.name === "vipCheckbox" && "checkBoxControl"} flexDisplay flexRow`}
                                    >
                                      {ele.subItems.map((subItem, index) => (
                                        <FormControlLabel
                                          key={index}
                                          control={
                                            <Checkbox
                                              id={subItem?.name}
                                              disabled={handleDisable(
                                                ele?.fieldDisabled,
                                                props?.disabled,
                                                ele.name,
                                              )}
                                              value={
                                                selectValues[subItem?.name] ||
                                                ""
                                              }
                                              defaultChecked={
                                                selectValues[subItem?.name]
                                              }
                                              onChange={(e, cb) => {
                                                setValue(
                                                  subItem?.name,
                                                  e.target.checked,
                                                );
                                                setSelectValues(
                                                  (prevValues) => ({
                                                    ...prevValues,
                                                    [subItem?.name]:
                                                      e.target.checked,
                                                  }),
                                                );
                                              }}
                                            />
                                          }
                                          label={
                                            <Typography
                                              variant={"head5"}
                                              className="colorBlack fw400"
                                            >
                                              {subItem?.checkboxLablel}
                                            </Typography>
                                          }
                                        />
                                      ))}
                                    </FormGroup>
                                  ) : ele?.switch ? (
                                    <FormGroup>
                                      <Box className="flex">
                                        {ele?.subItems?.map(
                                          (subItem, index) => (
                                            <Controller
                                              key={index}
                                              name={subItem?.name} // 👈 each switch has its own field
                                              control={control}
                                              rules={{
                                                required: subItem?.required,
                                              }}
                                              defaultValue={false}
                                              render={({ field }) => (
                                                <FormControlLabel
                                                  label={
                                                    <Typography
                                                      variant="head5"
                                                      className="colorBlack fw400"
                                                    >
                                                      {subItem?.checkboxLablel}
                                                    </Typography>
                                                  }
                                                  control={
                                                    <Switch
                                                      {...field}
                                                      id={subItem?.name}
                                                      name={subItem?.name}
                                                      disabled={handleDisable(
                                                        ele?.fieldDisabled,
                                                        props?.disabled,
                                                        ele?.name,
                                                      )}
                                                      checked={
                                                        field.value || false
                                                      }
                                                      onChange={(e) => {
                                                        const newValue =
                                                          !!e.target.checked;
                                                        field.onChange(
                                                          newValue,
                                                        );
                                                        handleInput(
                                                          e,
                                                          subItem?.name,
                                                          newValue,
                                                        );
                                                      }}
                                                    />
                                                  }
                                                />
                                              )}
                                            />
                                          ),
                                        )}
                                      </Box>
                                    </FormGroup>
                                  ) : ele?.google ? (
                                    <CommonGoogleAutoComplete
                                      defaultValue={selectValues[ele?.name]}
                                      landmarkMandatory={landmarkMandatory}
                                      getOptionLabel={(option) =>
                                        getOptionLabel(option)
                                      }
                                      disabled={handleDisable(
                                        ele?.fieldDisabled,
                                        props?.disabled,
                                        ele?.name,
                                      )}
                                      options={
                                        props?.locationData?.length > 0
                                          ? props?.locationData
                                          : []
                                      }
                                      onHandleChange={(event, value) => {
                                        onHandleChange(event, value, ele?.name);
                                      }}
                                      onInputChange={onInputChangeVal}
                                      ele={ele}
                                      register={register}
                                      fieldType={
                                        props?.[`${ele?.name}Loader`]?.fieldType
                                      }
                                      fieldLoader={
                                        props?.[`${ele?.name}Loader`]?.loader
                                      }
                                    />
                                  ) : ele?.textField ? (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: 1,
                                        width: "100%",
                                      }}
                                    >
                                      <Box
                                        sx={{ flex: 1 }}
                                        className="customTextField"
                                      >
                                        <TextField
                                          className={ele?.className}
                                          placeholder={ele?.placeholder}
                                          {...register(ele?.name, {
                                            required:
                                              mandatoryField?.field ===
                                                "from" &&
                                              ele?.name === "flightNo"
                                                ? true
                                                : ele?.required
                                                  ? ele?.required
                                                  : false,
                                          })}
                                          type={ele?.type}
                                          error={
                                            !!(
                                              errors[ele?.name] ||
                                              formError[ele?.name]
                                            )
                                          }
                                          onChange={(e) => {
                                            handleInput(e);
                                          }}
                                          disabled={handleDisable(
                                            ele?.fieldDisabled,
                                            props?.disabled,
                                            ele?.name,
                                          )}
                                          multiline={ele?.multiline || false}
                                          rows={ele?.row || ""}
                                          defaultValue={ele?.defaultValue}
                                          onWheel={
                                            numberInputOnWheelPreventChange
                                          }
                                          InputProps={{
                                            inputProps: {
                                              min:
                                                ele?.type === "number" ? 1 : "",
                                            },
                                            onInput:
                                              ele?.type === "number"
                                                ? handelNegativeInput
                                                : dummyFunctiom,
                                          }}
                                          onKeyDown={(e) => {
                                            if (
                                              e.which === 38 ||
                                              e.which === 40
                                            ) {
                                              e.preventDefault();
                                              return;
                                            }
                                          }}
                                        />
                                      </Box>
                                    </Box>
                                  ) : ele?.datePicker ? (
                                    <Box className="customDatePicker">
                                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                      >
                                        <DatePicker
                                          {...register(ele?.name, {
                                            required: ele?.required || false,
                                          })}
                                          format="DD/MM/YYYY"
                                          placeholderText="Please select a date"
                                          defaultValue={
                                            selectValues[ele?.name] &&
                                            dayjs(selectValues[ele?.name])
                                          }
                                          disabled={props?.disabled}
                                          minDate={dayjs(new Date())}
                                          onChange={(newDate) => {
                                            clearErrors("scheduleDate");
                                            setValue(ele?.name, newDate);
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              error={
                                                errors[ele?.name] ||
                                                formError[ele?.name]
                                              }
                                              inputProps={{
                                                ...params.inputProps,
                                              }}
                                              label="Select Date"
                                              placeholder="MM/DD/YYYY"
                                              fullWidth
                                              required
                                            />
                                          )}
                                        />
                                      </LocalizationProvider>
                                    </Box>
                                  ) : ele?.dateTimePicker ? (
                                    <CommonDateTimePicker
                                      ele={ele}
                                      register={register}
                                      selectValues={selectValues}
                                      handleDisable={handleDisable}
                                      errors={errors}
                                      propsData={props}
                                      formError={formError}
                                      clearErrors={clearErrors}
                                      setValue={setValue}
                                      minDate={minDate}
                                      edit={props?.editType}
                                      formValues={formValues}
                                    />
                                  ) : ele?.dashedBorder ? (
                                    <Box className="dashedBorder mt20"></Box>
                                  ) : ele?.guestDetails ? (
                                    <Box
                                      className="guestDetailsContainer"
                                      key={`${ele.name}container`}
                                    >
                                      {parseInt(
                                        formValues?.noOfTravelers || 0,
                                      ) -
                                        1 >
                                        0 && (
                                        <>
                                          <Typography
                                            variant="body2"
                                            className="flex fw600 colorBlack mb10"
                                          >
                                            {ele.label}
                                          </Typography>
                                          <Grid container spacing={2}>
                                            {guestDetails.map(
                                              (guest, index) => (
                                                <React.Fragment
                                                  key={`guest${index}`}
                                                >
                                                  <Grid item xs={12} sm={6}>
                                                    <Box className="guestInputContainer">
                                                      <p className="text-sm font-semibold mb-2">{`Guest ${index + 1} Name`}</p>
                                                      <CustomTextfield
                                                        ele={{
                                                          textField: true,
                                                          gridSize: 12,
                                                          required: false,
                                                          placeholder: `Enter Guest ${index + 1} Name`,
                                                          type: "text",
                                                          name: `guestName_${index}`,
                                                          label: `Guest ${index + 1} Name`,
                                                        }}
                                                        handleInput={(e) => {
                                                          handleGuestNameChange(
                                                            e,
                                                            index,
                                                          );
                                                          setValue(
                                                            `guestName_${index}`,
                                                            e.target.value,
                                                          );
                                                        }}
                                                        props={props}
                                                        register={register}
                                                        errors={errors}
                                                        formError={formError}
                                                        handleDisable={
                                                          handleDisable
                                                        }
                                                        handelNegativeInput={
                                                          handelNegativeInput
                                                        }
                                                        dummyFunctiom={
                                                          dummyFunctiom
                                                        }
                                                        numberInputOnWheelPreventChange={
                                                          numberInputOnWheelPreventChange
                                                        }
                                                      />

                                                      {errors[
                                                        `guestName_${index}`
                                                      ] && (
                                                        <Typography
                                                          variant="body2"
                                                          className="errorMessage"
                                                        >
                                                          {
                                                            errors[
                                                              `guestName_${index}`
                                                            ].message
                                                          }
                                                        </Typography>
                                                      )}
                                                    </Box>
                                                  </Grid>

                                                  <Grid item xs={12} sm={6}>
                                                    <Box className="guestInputContainer">
                                                      <p className="text-sm font-semibold mb-2">{`Guest ${index + 1} Phone Number`}</p>
                                                      <div className="flex flex-row gap-3 w-full">
                                                        <Controller
                                                          name={`guestCountryCode_${index}`}
                                                          control={control}
                                                          render={({
                                                            field,
                                                          }) => (
                                                            <Autocomplete
                                                              {...field}
                                                              size="medium"
                                                              name={`guestCountryCode_${index}`}
                                                              hiddenLabel={true}
                                                              disabled={handleDisable(
                                                                ele?.fieldDisabled,
                                                                props?.disabled,
                                                                ele?.name,
                                                              )}
                                                              value={
                                                                guestDetails[
                                                                  index
                                                                ]?.countryCode
                                                              }
                                                              popupIcon={
                                                                <ExpandMoreRoundedIcon />
                                                              }
                                                              options={
                                                                props?.countryCodeListData ||
                                                                []
                                                              }
                                                              filterSelectedOptions
                                                              onChange={(
                                                                e,
                                                                value,
                                                              ) => {
                                                                const updatedGuests =
                                                                  [
                                                                    ...guestDetails,
                                                                  ];
                                                                updatedGuests[
                                                                  index
                                                                ].countryCode =
                                                                  value;
                                                                setGuestDetails(
                                                                  updatedGuests,
                                                                );
                                                                setValue(
                                                                  `guestCountryCode_${index}`,
                                                                  value,
                                                                );
                                                              }}
                                                              clearIcon={null}
                                                              sx={{
                                                                minWidth:
                                                                  "120px",
                                                                "& .MuiAutocomplete-input":
                                                                  {
                                                                    minWidth:
                                                                      "60px !important",
                                                                    paddingRight:
                                                                      "40px !important",
                                                                  },
                                                                "& .MuiAutocomplete-endAdornment":
                                                                  {
                                                                    right:
                                                                      "8px",
                                                                  },
                                                              }}
                                                              renderOption={(
                                                                props,
                                                                option,
                                                              ) => (
                                                                <Box
                                                                  {...props}
                                                                  sx={{
                                                                    display:
                                                                      "flex",
                                                                    alignItems:
                                                                      "center",
                                                                    padding:
                                                                      "8px 12px",
                                                                    minWidth:
                                                                      "100px",
                                                                  }}
                                                                >
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      whiteSpace:
                                                                        "nowrap",
                                                                    }}
                                                                  >
                                                                    {
                                                                      option?.label
                                                                    }
                                                                  </Typography>
                                                                </Box>
                                                              )}
                                                              renderInput={(
                                                                params,
                                                              ) => (
                                                                <TextField
                                                                  {...params}
                                                                  margin="normal"
                                                                  sx={{
                                                                    "& .MuiOutlinedInput-root":
                                                                      {
                                                                        minWidth:
                                                                          "120px",
                                                                      },
                                                                  }}
                                                                  inputProps={{
                                                                    ...params.inputProps,
                                                                    autoComplete:
                                                                      "disabled",
                                                                    style: {
                                                                      minWidth:
                                                                        "60px",
                                                                      paddingRight:
                                                                        "8px",
                                                                    },
                                                                  }}
                                                                />
                                                              )}
                                                            />
                                                          )}
                                                        />

                                                        <CustomTextfield
                                                          ele={{
                                                            textField: true,
                                                            gridSize: 12,
                                                            required: false,
                                                            placeholder: `Enter Guest ${index + 1} Phone Number`,
                                                            type: "tel",
                                                            name: `guestPhone_${index}`,
                                                            label: `Guest ${index + 1} Phone`,
                                                          }}
                                                          handleInput={(e) => {
                                                            handleGuestPhoneChange(
                                                              e,
                                                              index,
                                                            );
                                                            setValue(
                                                              `guestPhone_${index}`,
                                                              e.target.value.replace(
                                                                /\D/g,
                                                                "",
                                                              ),
                                                            );
                                                          }}
                                                          props={props}
                                                          register={register}
                                                          errors={errors}
                                                          formError={formError}
                                                          handleDisable={
                                                            handleDisable
                                                          }
                                                          handelNegativeInput={
                                                            handelNegativeInput
                                                          }
                                                          dummyFunctiom={
                                                            dummyFunctiom
                                                          }
                                                          numberInputOnWheelPreventChange={
                                                            numberInputOnWheelPreventChange
                                                          }
                                                        />
                                                      </div>
                                                      {/* Show error message for guest phone */}
                                                      {errors[
                                                        `guestPhone_${index}`
                                                      ] && (
                                                        <Typography
                                                          variant="body2"
                                                          className="errorMessage"
                                                        >
                                                          {
                                                            errors[
                                                              `guestPhone_${index}`
                                                            ].message
                                                          }
                                                        </Typography>
                                                      )}
                                                    </Box>
                                                  </Grid>
                                                </React.Fragment>
                                              ),
                                            )}
                                          </Grid>
                                        </>
                                      )}
                                    </Box>
                                  ) : (
                                    ""
                                  )}
                                </FormControl>
                              </Box>
                              {/* errors will return when field validation fails  */}
                              {errors[ele?.name] && (
                                <Typography
                                  variant={"body2"}
                                  className="errorMessage"
                                >
                                  {errors[ele?.name]?.message ||
                                    "This field is required"}
                                </Typography>
                              )}
                              {formError[ele?.name] && (
                                <div className="errorMessage">
                                  {formError[ele?.name]}
                                </div>
                              )}
                            </FormControl>
                          </Box>
                        </Grid>
                      );
                    })}
                </Grid>
              </Box>
            ))}

          {props?.fareBreakup && (
            <>
              <FareBreakUp dutyTypeLabel={props?.dutyTypeLabel} />
              <CabFacilities />
            </>
          )}
          {props?.button && props?.button !== "dialogButton" && (
            <Box className="mb20">
              <CommonButton name={props?.button} type="submit" />
            </Box>
          )}
          {props?.button && props?.button === "dialogButton" && (
            <Box>
              <Grid container className="btnDialogContainer mt10">
                <Grid item xs={6} className="justifyCenter">
                  <CommonButton
                    name={"Cancel"}
                    type="submit"
                    btnClass="cancelAddBtn"
                    onClick={props?.handleClose}
                  />
                </Grid>
                <Grid item xs={6} className="justifyCenter">
                  <CommonButton
                    name={props?.selectType}
                    type="submit"
                    btnClass="buttonSubmitDialog"
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </form>
      </div>

      {/* Placard Preview Modal */}
      {previewModal && (
        <PlacardModal
          open={previewModal}
          handleClose={handlePreviewClose}
          text={selectedTripId}
        />
      )}
    </div>
  );
}
